import { render, staticRenderFns } from "./ApplicationReview.vue?vue&type=template&id=21d0655d&scoped=true&"
import script from "./ApplicationReview.vue?vue&type=script&lang=js&"
export * from "./ApplicationReview.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationReview.vue?vue&type=style&index=0&id=21d0655d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d0655d",
  null
  
)

export default component.exports